import { useI18n } from '@i18n';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { deDE, enUS } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { language_enum } from '@predium/enums';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { PropsWithChildren } from 'react';
// When adding a new locale: import it here
import 'dayjs/locale/de';
import 'dayjs/locale/en-gb';

dayjs.extend(relativeTime);

const DATE_LOCALES = {
  [language_enum.deDE]: 'de',
  [language_enum.enGB]: 'en-gb',
} satisfies Record<language_enum, string>;

const LOCALE_TEXTS = {
  [language_enum.deDE]: deDE.components.MuiLocalizationProvider.defaultProps.localeText,
  [language_enum.enGB]: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
} satisfies Record<language_enum, object>;

/**
 * Sets the Language for the DatePicker component where the current language has to be mapped to a language adapter of the underlying date library.
 */
export const DatePickerLanguageProvider = ({ children }: PropsWithChildren) => {
  const { language } = useI18n();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={DATE_LOCALES[language]}
      localeText={LOCALE_TEXTS[language]}
    >
      {children}
    </LocalizationProvider>
  );
};
